import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {
  GetUserInfo,
  PensionCalculator, RetireePensionCalculator,
} from "../../redux/selfService/selfServiceSlice";
import React, {useEffect, useState} from "react";
import LoadingSpinner from "../../components/LoadingSpinner";
import PageName from "../../components/PageName";
import SuccessModal from "../../components/SuccessModal";
import Card from "../../components/Base/Card";
import ErrorViewer from "../../components/ErrorViewer";
import Required from "../../components/Required";
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import BaseDatePicker from "../../components/Base/BaseDatePicker";
import CalculatedPensionModal from "./CalculatedPensionModal";
import TimeOutActivityLayout from "../auth/inactivity-timeout-v2";

const PensionCalculatorPage = ()=>{
    const dispatch = useAppDispatch();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [calculatedPension, setCalculatedPension] = useState({});
    const { isLoading } = useAppSelector((state) => state?.selfService);
    const { user } = useAppSelector((state) => state?.auth);
  const { userInfo, isLoading: isUserInfoLoading } = useAppSelector((state) => state?.selfService);

    useEffect(()=>{
      dispatch(GetUserInfo());
    }, []);

    const validationSchema = Yup.object().shape({
        consolidatedSalary: Yup.string().required("Please enter"),
        basic: Yup.string().required("Please enter"),
        housing: Yup.string().required("Please enter"),
        transport: Yup.string().required("Please enter"),
        gender: Yup.string().required("Please enter"),
        age: Yup.string().required("Please enter"),
        transferType: Yup.string().required("Please enter"),
    });

    const defaultValues = {
        consolidatedSalary: "",
        basic: "",
        housing: "",
        transport: "",
        gender:  userInfo.gender,
        age:  userInfo.age.toString(),
        transferType: ""
    }

    // useEffect(()=>{
    //   console.log('we settignuser info', userInfo)
    //   reset({
    //     ...defaultValues,
    //     age: userInfo.age.toString(),
    //     gender: userInfo.gender,
    //   })
    // }, [])


    
useEffect(() => {
    if (userInfo) {
      reset({
        ...defaultValues,
        age: userInfo.age.toString(),
        gender: userInfo.gender,
      });
    }
  }, [userInfo]);

    const { handleSubmit, register, setValue, reset, formState: { errors },} = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues
    });

    const onSubmit = (values: any) => {
        const formattedValue = {
            ...values,
            rsaBalance: user.contibutionBalance
        }
        if(values.transferType === "pensionCalculator") {
            dispatch(PensionCalculator(formattedValue)).then(res => {
                console.log('ths ', res)
                if (res?.type === 'selfService/PensionCalculator/fulfilled' && res.payload !== undefined) {
                    setCalculatedPension(res.payload)
                    reset(defaultValues)
                    setShowSuccessModal(true)

                }
            })
        } else {
            dispatch(RetireePensionCalculator(formattedValue)).then(res => {
                console.log('ths ', res)
                if (res?.type === 'selfService/RetireePensionCalculator/fulfilled' && res.payload !== undefined) {
                    setCalculatedPension(res.payload)
                    reset(defaultValues)
                    setShowSuccessModal(true)
                }
            })
        }
    }

    return (
        <TimeOutActivityLayout>
        <div className="statement-page">
            <PageName pageName={"Calculate your pension"}/>
            <div>
                <CalculatedPensionModal
                    showModal={showSuccessModal}
                    onClose={()=>setShowSuccessModal(false)}
                    pension={calculatedPension}
                />
                <div className="mx-4">


                    <div className="h1 text-grayscaleBody">
                        Pension Calculator
                    </div>
                    <div className="w-full">
                        <Card className="mb-8 bg-grayscaleBG">
                            <div className="section-card">
                                <div className="pt-12 whitespace-pre mr-6">
                                    Pension Calculator
                                </div>
                                <div className="w-full">
                                    <div className="form__row">
                                        <div className="form__group">
                                            <label htmlFor="consolidatedSalary" className="form__label">
                                                Consolidated Salary <Required />
                                            </label>
                                            <input placeholder="0" type="number" id="consolidatedSalary"
                                                   className="form__input" {...register("consolidatedSalary")} />
                                            {errors.consolidatedSalary && (
                                                <ErrorViewer message={errors.consolidatedSalary.message as string}/>
                                            )}
                                        </div>
                                        <div className="form__group">
                                            <label htmlFor="basic" className="form__label">
                                                Basic <Required />
                                            </label>
                                            <input placeholder="0" type="number" id="basic"
                                                   className="form__input" {...register("basic")} />
                                            {errors.basic && (
                                                <ErrorViewer message={errors.basic.message as string}/>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form__row">
                                        <div className="form__group">
                                            <label htmlFor="housing" className="form__label">
                                                Housing <Required />
                                            </label>
                                            <input placeholder="0" type="number" id="housing"
                                                   className="form__input" {...register("housing")} />
                                            {errors.housing && (
                                                <ErrorViewer message={errors.housing.message as string}/>
                                            )}
                                        </div>
                                        <div className="form__group">
                                            <label htmlFor="transport" className="form__label">
                                                Transport <Required />
                                            </label>
                                            <input placeholder="0" type="number" id="transport"
                                                   className="form__input" {...register("transport")} />
                                            {errors.transport && (
                                                <ErrorViewer message={errors.transport.message as string}/>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form__row">
                                        <div className="form__group">
                                            <label htmlFor="transferType" className="form__label">
                                                Calculator Type  <Required />
                                            </label>
                                            <select id="transferType" className="form__select"  {...register("transferType")}>
                                                <option value="" disabled>Select Transfer Type</option>
                                                <option value="pensionCalculator">Pension Calculator</option>
                                                <option value="retireePensionCalculator">Retiree Pension Calculator</option>
                                            </select>
                                            {errors.transferType && (
                                                <ErrorViewer message={errors.transferType.message as string}/>
                                            )}
                                        </div>
                                        <div className="form__group">
                                            <label htmlFor="gender" className="form__label">
                                                Gender <Required />
                                            </label>
                                            <select  id="gender" className="form__select" {...register("gender")}>
                                                <option value="" disabled>Select Gender</option>
                                                <option value="M">Male</option>
                                                <option value="F">Female</option>
                                            </select>
                                            {errors.gender && (
                                                <ErrorViewer message={errors.gender.message as string}/>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form__row">
                                        <div className="form__group">
                                            <label htmlFor="age" className="form__label">
                                                Age <Required />
                                            </label>
                                            <input placeholder="0" type="number" id="transport"
                                                   className="form__input" {...register("age")} />
                                            {errors.age && (
                                                <ErrorViewer message={errors.age.message as string}/>
                                            )}
                                        </div>
                                        <div className="form_group"></div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                        <div className="flex justify-end text-primary mb-40">
                            <button
                                className="btn btn-primary font-semibold mr-4"
                                onClick={handleSubmit(onSubmit)}
                                disabled={isLoading}
                            >
                                {
                                    isLoading ? <LoadingSpinner /> : "Calculate"
                                }
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        </TimeOutActivityLayout>
    )
}
export default PensionCalculatorPage;